/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Spellcheck.
 * @export
 */
export const ICON_SPELLCHECK = (
  <svg fill="none" height="28" viewBox="0 0 28 28" width="28" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M14.4348 18.0295C15.2398 18.0295 15.7765 17.2245 15.4848 16.4895L10.5265 3.87779C10.2815 3.25946 9.69812 2.86279 9.04479 2.86279C8.39145 2.86279 7.80812 3.25946 7.56312 3.87779L2.60479 16.4895C2.31312 17.2245 2.86145 18.0295 3.65479 18.0295C4.12145 18.0295 4.54145 17.7378 4.71645 17.2945L5.74312 14.5295H12.3231L13.3731 17.3061C13.5481 17.7378 13.9681 18.0295 14.4348 18.0295ZM6.62979 12.1961L9.04479 5.75613L11.4598 12.1961H6.62979ZM14.8781 22.3228L23.4998 13.7011C23.9431 13.2578 24.6898 13.2578 25.1331 13.7128C25.5881 14.1678 25.5881 14.9028 25.1331 15.3578L15.7065 24.7961C15.2515 25.2511 14.5165 25.2511 14.0615 24.7961L9.76812 20.5028C9.31312 20.0478 9.31312 19.3128 9.76812 18.8578C9.98609 18.6393 10.282 18.5166 10.5906 18.5166C10.8992 18.5166 11.1952 18.6393 11.4131 18.8578L14.8781 22.3228Z"
      fill="#707070"
      fillRule="evenodd"
    />
  </svg>
);
